import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Timeline = styled.div<{ height: number }>`
  position: relative;
  width: 100%;
  background-color: #f3f4f6;
  border-radius: 4px;
  height: ${props => props.height}px;
`;

export const TickContainer = styled.div`
  position: relative;
  width: 100%;
  height: 12px;
  margin-top: 4px;
`;

export const Tick = styled.div<{ leftPosition: number }>`
  position: absolute;
  width: 1px;
  height: 8px;
  background-color: #9ca3af;
  left: ${props => props.leftPosition}%;
`;

export const Dot = styled.div<{
  leftPosition: number;
  width: number;
  height: number;
  backgroundColor: string;
  borderRadius: string;
}>`
  position: absolute;
  top: 0;
  transition: all 0.2s;
  left: ${props => props.leftPosition}%;
  width: ${props => props.width}%;
  height: ${props => props.height}px;
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => props.borderRadius};
`;